import { HttpClient } from "@angular/common/http";
import { TranslateLoader } from "@ngx-translate/core";
import { catchError, forkJoin, map, Observable, of } from "rxjs";
import { environment } from "src/environments/environment";

import { merge } from "../utils/merge";

export class CustomLoader implements TranslateLoader {
  constructor(
    private readonly http: HttpClient,
    private readonly programSlug: string,
  ) {}

  public getTranslation(lang: string): Observable<Record<string, any>> {
    return forkJoin({
      default: this.http.get(`./assets/i18n/${lang}.json?${environment.release}`),
      specific: this.http.get(`./assets/i18n/${this.programSlug}_${lang}.json?${environment.release}`).pipe(catchError(() => of({}))),
    }).pipe(
      map(({ default: defaultTranslations, specific: langTranslations }) =>
        merge(defaultTranslations, langTranslations),
      ),
    );
  }
}
